export default __webpack_public_path__ + "static/cafe girl-a7c14a4dd8e4ba3c3371649265b07a41.png";